import { render } from "./EstimateCorpCard.vue?vue&type=template&id=60fdf5b8"
import script from "./EstimateCorpCard.vue?vue&type=script&lang=js"
export * from "./EstimateCorpCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__